import React from 'react';
import { connect } from 'react-redux';
import objectPath from 'object-path';
import * as builder from '../../ducks/builder';
import Icon1 from './Icon1';
import Icon2 from './Icon2';
import { Button } from '@material-ui/core';

class Footer extends React.Component {
  state = {
    isMobile: window.innerWidth <= 1024,
  };

  handleWindowResize = () => this.setState({ isMobile: window.innerWidth <= 1024 });

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  mobileFooter = () => {
    return (
      <div className={`kt-container ${this.props.footerContainerClasses}`}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            alignItems: 'center',
            textAlign: 'center',
            padding: '12px 8px',
            borderRadius: 8,
          }}
        >
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', width: '100%' }}>
            <div>
              <a href='tel:8 800 201 03 50' rel='noopener noreferrer' className='kt-link'>
                <span style={{ color: '#d01c1f' }}>8 800 201 03 50</span>
              </a>
              <div style={{ fontSize: 13, color: '#000' }}>Звонок бесплатный</div>
            </div>
            <div>
              <a href='tel:8 964 965 28 28' rel='noopener noreferrer' className='kt-link'>
                <span style={{ color: '#d01c1f' }}>8 964 965 28 28</span>
              </a>
              <div style={{ fontSize: 13, color: '#000' }}>Всегда поможем Вам</div>
            </div>
          </div>
          <div style={{ fontSize: 13, color: '#000' }}>
            <a rel='noopener noreferrer' className='kt-link' href={'/documents/legacy/read'}>
              Пользовательское соглашение
            </a>{' '}
            |{' '}
            <a href={'/documents/privacy/read'} rel='noopener noreferrer' className='kt-link'>
              Политика конфиденциальности
            </a>
          </div>
          <div style={{ fontSize: 13, color: '#000' }}>
            <a
              href='https://start-mobile.net/ru/sozdanie-marketplejsa-razrabotka-pod-klyuch-cena/'
              target='_blank'
              rel='noopener noreferrer'
              className='kt-link'
            >
              Разработка: Start Mobile
            </a>
          </div>
        </div>

        <div
          style={{
            marginTop: 16,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <span style={{ fontSize: 14, color: '#000', fontWeight: 600 }}>
            Мобильное приложение продавца и покупателя
          </span>
          <div className='kt-footer__menu' style={{ display: 'flex', gap: 16 }}>
            <Button
              onClick={() => {
                window.location.href = 'https://apps.rustore.ru/app/us.startmobile.wholesale';
              }}
              style={{ padding: 0, height: 50 }}
            >
              <Icon1 />
            </Button>
            <Button
              onClick={() => {
                window.location.href =
                  'https://apps.apple.com/ru/app/одежда-оптом/id6476561188';
              }}
              style={{ padding: 0, height: 50 }}
            >
              <Icon2 />
            </Button>
          </div>
        </div>
      </div>
    );
  };
  webFooter = () => {
    return (
      <div className={`kt-container ${this.props.footerContainerClasses}`}>
        <div
          className='kt-footer__copyright'
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <div style={{ display: 'flex', gap: '24px' }}>
            <div>
              <a href='tel:8 800 201 03 50' rel='noopener noreferrer' className='kt-link'>
                <span style={{ color: '#d01c1f' }}>8 800 201 03 50</span>
              </a>
              <div style={{ fontSize: 14, color: '#000000' }}>Звонок бесплатный</div>
            </div>
            <div>
              <a href='tel:8 964 965 28 28' rel='noopener noreferrer' className='kt-link'>
                <span style={{ color: '#d01c1f' }}>8 964 965 28 28</span>
              </a>
              <div style={{ fontSize: 14, color: '#000000' }}>Всегда поможем Вам</div>
            </div>
          </div>
          <div>
            <a
              rel='noopener noreferrer'
              className='kt-link'
              href={'/documents/legacy/read'}
              style={{ fontSize: 13, color: '#000',fontWeight: 'normal' }}
            >
              Пользовательское соглашение
            </a>
            <span style={{ margin: '0 8px' }}>|</span>
            <a
              href={'/documents/privacy/read'}
              rel='noopener noreferrer'
              className='kt-link'
              style={{ fontSize: 13, color: '#000', fontWeight: 'normal' }}
            >
              Политика конфиденциальности
            </a>
          </div>
          <div>
            <a
              href='https://start-mobile.net/ru/sozdanie-marketplejsa-razrabotka-pod-klyuch-cena/'
              target='_blank'
              rel='noopener noreferrer'
              className='kt-link'
              style={{ fontSize: 13, color: '#000000', fontWeight: 'normal' }}
            >
              Разработка: Start Mobile
            </a>
          </div>
        </div>
        <div style={{ marginRight: 20 }}>
          <span style={{ fontSize: 14, color: '#000000', fontWeight: '600' }}>
            Мобильное приложение продавца и покупателя
          </span>
          <div className='kt-footer__menu'>
            <Button
              onClick={() => {
                window.location.href = 'https://apps.rustore.ru/app/us.startmobile.wholesale';
              }}
              style={{ padding: 0, height: 50, marginRight: 25 }}
            >
              <Icon1 />
            </Button>
            <Button
              onClick={() => {
                window.location.href =
                  'https://apps.apple.com/ru/app/одежда-оптом/id6476561188';
              }}
              style={{ padding: 0, height: 50, marginRight: 20 }}
            >
              <Icon2 />
            </Button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div
        className={`kt-footer ${this.props.footerClasses} kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop`}
        id='kt_footer'
      >
        {this.state.isMobile ? this.mobileFooter() : this.webFooter()}
      </div>
    );
  }
}

const mapStateToProps = store => ({
  fluid: objectPath.get(store.builder.layoutConfig, 'footer.self.width') === 'fluid',
  footerClasses: builder.selectors.getClasses(store, {
    path: 'footer',
    toString: true,
  }),
  footerContainerClasses: builder.selectors.getClasses(store, {
    path: 'footer_container',
    toString: true,
  }),
});

export default connect(mapStateToProps)(Footer);
